/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React                  from 'react'
import axios                  from 'axios'
import Box                    from "@material-ui/core/Box"
import Grid                   from "@material-ui/core/Grid"
import Paper                  from "@material-ui/core/Paper"
import Typography             from "@material-ui/core/Typography"

import HistoryCreateComponent from '../Components/HistoryCreateComponent'

const HistoryCreatePage = () => {

   return (
      <Box>
         <HistoryCreateComponent />
      </Box>
   )
}

export default HistoryCreatePage
